module.exports = __webpack_public_path__ + "img/nounproject_TEX File_342079.2a113cd0.svg";